import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    authenticated: false,
  },
  reducers: {
    logout: (state) => {
      state.authenticated = false;
    },
    login: (state) => {
      state.authenticated = true;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
